import React from 'react';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { AppStore } from '../stores/App.store';
import { normalizePath } from '../common/methods/language';
import compose from 'lodash/flowRight';

const urlRegex = /^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

const LanguageLink = ({ to, appStore: { currentLanguage }, ...rest }) => {
    const isExternal = typeof to === "string" && urlRegex.test(to);

    if (isExternal) {
        return (
            <a
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                {...rest}
            />
        );
    }

    return (
        <NavLink to={normalizePath(currentLanguage, to)} {...rest} />
    );
};

LanguageLink.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    appStore: PropTypes.instanceOf(AppStore).isRequired,
};

export default compose(
    inject('appStore'),
    observer
)(LanguageLink);



// WEBPACK FOOTER //
// ./src/elements/LanguageLink.jsx